import React from 'react';
import { ModuleBridge, TopActionBar, Tabs } from '../../components';
import AdvancedSettingsDropdown from './AdvancedSettingsDropdown';
import CloudTagsDropdown from './CloudTagsDropdown';
import MigrationInstructionsDropdown from './MigrationInstructionsDropdown';

import './MigrationSettings.scss';

export const MigrationSettings = () => {
    const items = [
        {
            key: 'advanced_settings',
            label: 'Advanced Settings',
            children: <AdvancedSettingsDropdown />,
        },
        {
            key: 'tags',
            label: 'Cloud Tags',
            children: <CloudTagsDropdown />,
        },
        {
            key: 'migration_instructions',
            label: 'Migration Instructions',
            children: <MigrationInstructionsDropdown />,
        },
        {
            key: 'migration_os_hardening',
            label: 'OS Hardening',
        },
        {
            key: 'migration_powershell',
            label: 'PowerShell',
        },
        {
            key: 'migration_rivermeadow_tags',
            label: 'RiverMeadow Tags',
        },
    ];

    const handleTabChange = (key) => {
        switch (key) {
            case 'advanced_settings':
                window.handleSettingsLinkClick('advanced_settings');
                break;
            case 'tags':
                window.handleSettingsLinkClick('tags');
                break;
            case 'migration_instructions':
                window.handleSettingsLinkClick('migration_instructions');
                break;
            case 'migration_os_hardening':
                window.handleSettingsLinkClick('migration_os_hardening');
                break;
            case 'migration_powershell':
                window.handleSettingsLinkClick('migration_powershell');
                break;
            case 'migration_rivermeadow_tags':
                window.handleSettingsLinkClick('migration_rivermeadow_tags');
                break;
            default:
                break;
        }
    };

    return (
        <div className="migration-settings">
            <TopActionBar>
                <Tabs
                    defaultActiveKey={window.location.search.split('section=')[1]}
                    items={items}
                    onChange={handleTabChange}
                />
            </TopActionBar>
            <div id="backbone_migration_settings_wrapper"></div>
            <ModuleBridge moduleId="migration_settings_module" />
        </div>
    );
};
